import React, { Component } from 'react';
import { combineLatest } from 'rxjs';
import { InjectorService } from '@tencent/ioc';
import { StateManager } from './state-manager.js';
import { map, throttleTime } from 'rxjs/operators';

/**
 * 状态高阶组件
 *
 * @typeParam T - 需要注入到组件的 props 接口
 * @typeParam U - 组件自身暴露的 props 接口
 *
 * @param keys - 注入的 props 的 key
 * @param sync -
 * 是否强制同步更新，当 key 的数量超过一个时会默认异步更新，
 * 避免多个属性同时更新导致多次渲染
 * @param throttle - sync 为 false 且 key 的数量超过一个时，异步更新的等待时间
 *
 * @public
 */
function withState(keys, sync = false, throttle = 10, scheduler) {
    return (Element) => { var _a, _b; var _c; return _c = class C extends Component {
            constructor(props) {
                super(props);
                this.observables = {};
                this.store = InjectorService.get(StateManager);
                this.state = keys.reduce((acc, key) => {
                    acc[key] = this.getObservable(key).getValue();
                    return acc;
                }, {});
            }
            getObservable(key) {
                if (!this.store.has(key)) {
                    this.store.register(key, null);
                }
                const observable = this.store.get(key);
                this.observables[key] = observable.pipe(map(value => ({ [key]: value })));
                return observable;
            }
            componentDidMount() {
                const throttleConfig = { leading: false, trailing: true };
                const observable = combineLatest([...Object.values(this.observables)]);
                if (keys.length > 1 && !sync) {
                    this.subscription = observable.pipe(throttleTime(throttle, scheduler, throttleConfig))
                        .subscribe((combined) => {
                        const newState = combined.reduce((acc, cur) => (Object.assign(Object.assign({}, acc), cur)), {});
                        this.setState(newState);
                    });
                }
                else {
                    this.subscription = observable.subscribe((combined) => {
                        const newState = combined.reduce((acc, cur) => (Object.assign(Object.assign({}, acc), cur)), {});
                        this.setState(newState);
                    });
                }
            }
            componentWillUnmount() {
                this.subscription.unsubscribe();
            }
            render() {
                return (React.createElement(Element, Object.assign({}, this.props, this.state)));
            }
        },
        _c.displayName = (_b = (_a = Element.displayName) !== null && _a !== void 0 ? _a : Element.name) !== null && _b !== void 0 ? _b : 'WithStateComponent',
        _c; };
}

export { withState };
//# sourceMappingURL=with-state.js.map
